<template>

  <select-input
    :label="label"
    v-model="formData"
    value-key="value"
    label-value="label"
    :placeholder="placeholder"
    :size="size"
    :list="selects"
    :required="required"
    :disabled="disabled"
    @change="updated" />

</template>

<script>

export default {
  name: 'select-site-status',

  props: {
    label: {
      type: String,
      default: 'Site Status'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },
    placeholder: {
      type: String,
      default: 'Site Status'
    },
    helpText: {
      type: String,
      default: null
    }
  },


  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  },

  data () {
    return {
      formData: this.value,
      selects: this.getConfig().selects.siteStatus
    }
  }
}
</script>

<style>
.el-select {display:block;}
</style>



// WEBPACK FOOTER //
// SelectSiteStatus.vue?6ff53c94